import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  FAQ_PATH,
  LEGAL_NOTICES_PATH,
  OUR_TEAM_PATH,
  TERMS_OF_USE_PATH,
} from './../../config/routes'

const FooterLinks = () => {
  const { t } = useTranslation()
  const isOurTeamEnabled = process.env.REACT_APP_TOGGLE_OUR_TEAM === 'true'

  const links = [
    { to: FAQ_PATH, label: t('FAQ') },
    ...(isOurTeamEnabled ? [{ to: OUR_TEAM_PATH, label: t('OUR_TEAM') }] : []),
    { to: LEGAL_NOTICES_PATH, label: t('LEGAL_NOTICES') },
    { to: TERMS_OF_USE_PATH, label: t('TERMS_OF_USE') },
  ]

  return (
    <div className="footer-links text-center mb-2">
      {links.map((link, index) => (
        <React.Fragment key={link.to}>
          <Link to={link.to}>{link.label}</Link>
          {index < links.length - 1 && ' | '}
        </React.Fragment>
      ))}
    </div>
  )
}

export default FooterLinks
